import React from "react";
import {
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import styles from "../../../Meta.module.css";
import helpIcon from "../../../../../../../../assets/images/helpIcon.svg";

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: "400",
  lineHeight: "18px",
  fontSize: "14px",
  color: "#FFFFFF",
  textTransform: "capitalize",
  padding: theme.spacing(1),
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: "400",
  fontSize: "13px",
  color: "#142C44",
  padding: theme.spacing(1),
  paddingTop: "15px",
  paddingBottom: "10px",
}));

function StreamsTable(props: any) {
  const { handleTabChange, handleTabSelect, metaStreams, branch } = props;

  const handleViewLeads = (id: string) => {
    handleTabChange(1);
    handleTabSelect("responses", id);
  };

  return (
    <TableContainer sx={{ borderRadius: "6PX", border: "1px solid #ECEFF2" }}>
      <Table
        sx={{
          minWidth: 700,
        }}
      >
        <TableHead
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 999,
            background: "#073E53",
          }}
        >
          <TableRow>
            <StyledTableCellHead sx={{ minWidth: 180, padding: "16px" }}>
              Streams
            </StyledTableCellHead>
            <StyledTableCellHead sx={{ minWidth: 180 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  justifyContent: "center",
                }}
              >
                Credits Used
                <Tooltip
                  arrow
                  placement="right"
                  title={
                    "Credit is deducted based on Round Robin logic from all the branches associated to the stream"
                  }
                  PopperProps={{
                    style: { zIndex: 999999 },
                  }}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "#101828",
                        color: "#fff",
                        fontSize: "12px",
                        fontWeight: "500",
                        padding: "8px 12px",
                        "& .MuiTooltip-arrow": {
                          color: "#101828",
                        },
                      },
                    },
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img src={helpIcon} alt="helpIcon" />
                  </span>
                </Tooltip>
              </div>
            </StyledTableCellHead>
            <StyledTableCellHead sx={{ minWidth: 180 }} align="center">
              Total Response
            </StyledTableCellHead>

            <StyledTableCellHead sx={{ minWidth: 180 }} align="center">
              Actions
            </StyledTableCellHead>
            <StyledTableCellHead sx={{ minWidth: 180 }} align="center">
              Status
            </StyledTableCellHead>
          </TableRow>
        </TableHead>
        <TableBody sx={{ background: "#fff" }}>
          {metaStreams?.map((item: any, index: any) => (
            <TableRow key={index}>
              <StyledTableCellBody
                sx={{
                  textTransform: "capitalize",
                  fontWeight: "500",
                }}
              >
                {item?.streamName}
              </StyledTableCellBody>
              <StyledTableCellBody align="center">
                {item?.branchCreditUsage?.[branch?.id]?.creditUsed ?? 0}
              </StyledTableCellBody>
              <StyledTableCellBody align="center">
                {item?.totalLeadSynced}{" "}
              </StyledTableCellBody>

              <StyledTableCellBody>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    onClick={() => handleViewLeads(item?.id)}
                    className={styles.streamActionBtn}
                  >
                    View Leads
                  </button>
                </div>
              </StyledTableCellBody>
              <StyledTableCellBody>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      background:
                        item?.status === "ACTIVE"
                          ? "#11C89B"
                          : item?.status === "INACTIVE"
                          ? "#8A94A6"
                          : "#f1a000",
                      color: "#FFF",
                      fontSize: "13PX",
                      padding: "4px 20px",
                      width: "fit-content",
                      borderRadius: "6px",
                      textTransform: "capitalize",
                    }}
                  >
                    {item?.status?.toLowerCase()}
                  </div>
                </div>
              </StyledTableCellBody>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {metaStreams?.length === 0 && (
        <div
          style={{
            fontSize: "14px",
            fontWeight: "500",
            textTransform: "capitalize",
            color: " #667085",
            display: "flex",
            alignItems: "center",
            gap: "2px",
            justifyContent: "center",
            marginTop: "2%",
            marginBottom: "2%",
          }}
        >
          <div style={{ color: " #142C44" }}>No streams found.</div>
        </div>
      )}
    </TableContainer>
  );
}

export default StreamsTable;
